__turbopack_context__.v({
  "turnstile": "YCvgDq_turnstile",
});
